import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export default function CrossPostSubscriptionsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.CrossPostSubscriptions', {
		url: '/admin/crossPost/subscriptions',
		controllerAs: 'vm',
		controller: CrossPostSubscriptionsCtrl,
		templateUrl: '/ng/hub/CrossPost/Subscriptions/CrossPostSubscriptionsCtrl.html?' + window.BUILD,
		permission: ['manage_tags'],
		resolve: {
			$style: () => AssetManager.css('/ng/hub/CrossPost/Subscriptions/CrossPostSubscriptionsCtrl.css'),
			// TODO: use Identity.allowedClients() instead of this endpoint;
			/// just need to make sure that comes in in same format as
			/// it is coming from /cross_post/allowed_hubs
			allowedHubs: ApiResourcify.endpoint('/cross_post/allowed_hubs'),
			selectedHubs: ApiResourcify.endpoint('/cross_post/selected_hubs'),
			selectedTags: ApiResourcify.endpoint('/cross_post/subscriptions'),
		},
	});
}

class CrossPostSubscriptionsCtrl {
	constructor(
		$window,
		$scope,
		$stateParams,
		$q,
		Api,
		Identity,
		allowedHubs,
		Cfg,
		notifications,
		selectedHubs,
		selectedTags
	) {
		'ngInject';
		if (Cfg.read('Features.cross_post') !== '1') {
			$window.location.href = '/posts/intelligence';
		}
		this.$q = $q;
		this.$window = $window;
		this.Api = Api;
		this.notifications = notifications;
		this.Identity = Identity;
		this.allowedHubs = allowedHubs;
		this.allowedHubIds = allowedHubs.map(hub => hub.id);
		this.selectedHubIds = selectedHubs.map(hub => hub.id);
		// a list of all tags from every allowed hub
		this.hubTags = [];
		this.getHubTags();
		// hubs that are checked
		this.tagsOfSelectedHubs = [];
		// this.selectAllHubs = this.allHubsSelected();
		// tags that are checked (only need one in array per tag name if there are duplicates)
		this.selectedTags = _.uniq(selectedTags.map(tag => tag.value));
		// this.selectAllTags = false;
		// update list of available tags every time selected hubs changes
		$scope.$watch('vm.selectedHubIds', this.updateTagsOfSelectedHubs.bind(this), true);
		// watched so we can update the `this.selectAllTags` checkbox
		// $scope.$watch('vm.selectedTags', this.updateSelectedTags.bind(this), true);
		this.crossPostDestination = Cfg.read('CrossPost.destination');
	}

	// requests tags for each hub
	getHubTags() {
		this.allowedHubIds.forEach(hubId => {
			this.Api.get('/tags', null, { Hubs: hubId }).then(tags => {
				if (!tags || tags.length == 0) {
					return;
				}
				tags.forEach(tag => {
					tag.hub_id = hubId;
				});
				this.hubTags = this.hubTags.concat(tags);
				this.updateTagsOfSelectedHubs();
				// this.selectAllTags = this.allTagsSelected();
			});
		});
	}

	// updates list of available tags based on the hubs that are selected
	updateTagsOfSelectedHubs() {
		this.tagsOfSelectedHubs = [];
		this.selectedHubIds.forEach(hubId => {
			var hubTags = this.hubTags;
			// this.tagsOfSelectedHubs = this.tagsOfSelectedHubs.concat(_.where(hubTags, {hub_id:hubId}));
			var tags = _.where(hubTags, { hub_id: hubId });
			this.tagsOfSelectedHubs = this.tagsOfSelectedHubs.concat(_.pluck(tags, 'name'));
		});
		// this.selectAllHubs = this.allHubsSelected();
		// dedupe: they are removed from the displayed list, but not from the
		/// list of all tags
		this.tagsOfSelectedHubs = _.uniq(this.tagsOfSelectedHubs);
	}

	// saves list of selected hubs and tags
	saveSubscriptions() {
		var subscriptions = [];
		// need to send an object to the API for each selected tag (selected tags
		/// are only a string of the tag name). this.hubTags has the data we need.
		this.selectedTags.forEach(tagName => {
			// there may be more than one thing in this.hubTags with that `.name`.
			/// It should find both. It needs one record in DB for each of them
			/// (if it is in a selected hub).
			this.hubTags.forEach(tag => {
				// only include it if is in a selected hub
				if (this.selectedHubIds.indexOf(tag.hub_id) > -1) {
					if (tag.name === tagName) {
						tag.type = 'tag';
						subscriptions.push(tag);
					}
				}
			});
		});
		var configUpdate = {
			code: 'CrossPost.destination',
			value: this.crossPostDestination,
			scope: 'hub',
			hub: this.Identity.currentClient().id,
		};
		var updates = [
			this.Api.patch('/cross_post/selected_hubs', { hubs: this.selectedHubIds }),
			this.Api.patch('/cross_post/subscriptions', { subscriptions }),
			this.Api.patch('/config/set', configUpdate),
		];

		// run in parallel because async
		this.$q.all(updates).then(() => {
			this.notifications.showSuccess({ message: 'Subscriptions saved' });
		});
	}

	cancel() {
		this.$window.history.go(-1);
	}
}
